import { gql } from '@apollo/client';

export const ACTIVITY_UPSERT = gql`
  mutation upsertActivity($input: activityInput!) {
    upsertActivity(input: $input) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      recordIdMission
      astreinte
      hoursPerDays
    }
  }
`;

export const SIGN_BLOOMER_ACTIVITY = gql`
  mutation signBloomerActivity($activityRecordID: ID!, $signerFullname: String) {
    signBloomerActivity(activityRecordID: $activityRecordID, signerFullname: $signerFullname) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      urlInvoicesS3
      urlAdditionalInvoicesS3
      signingEmbedBloomerId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
      CRAStatus
    }
  }
`;

export const SIGN_CLIENT_ACTIVITY = gql`
  mutation signClientActivity($signingDocumentID: ID!, $signerFullname: String) {
    signClientActivity(signingDocumentID: $signingDocumentID, signerFullname: $signerFullname) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      signingEmbedBloomerId
      signingEmbedClientId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
      CRAStatus
      mission {
        recordId
        contactOperations {
          recordId
          email
        }
        clientSocietyName
        bloomerFullName
        label
      }
    }
  }
`;

export const CANCEL_SIGN_BLOOMER_ACTIVITY = gql`
  mutation cancelSignBloomerActivity($activityRecordID: ID!) {
    cancelSignBloomerActivity(activityRecordID: $activityRecordID) {
      recordId
      month
      nbDaysWorked
      nbDaysMarkupWorked
      nbDaysMarkup2Worked
      nbDaysDetails
      astreinte
      billed
      validated
      signing
      signingDocumentId
      signedCount
      urlCraS3
      urlInvoicesS3
      urlAdditionalInvoicesS3
      signingEmbedBloomerId
      payed
      lastSupplierError
      supplierInvoiceStatus
      externalSupplierInvoiceId
      hoursPerDays
      CRAStatus
    }
  }
`;
export const UPLOAD_ACTIVITY_FILE = gql`
  mutation uploadActivityFile($input: uploadActivityInput!) {
    uploadActivityFile(input: $input)
  }
`;

export const GET_ELECTRONICSIGN_LINK = gql`
  mutation getElectronicSignLink($externalDocumentId: ID!, $signerId: ID!) {
    getElectronicSignLink(externalDocumentId: $externalDocumentId, signerId: $signerId)
  }
`;

export const CREATE_ACTIVITY_CUSTOMER_INVOICE = gql`
  mutation createActivityCustomerInvoice($activityRecordID: ID!, $force: Boolean) {
    createActivityCustomerInvoice(activityRecordID: $activityRecordID, force: $force) {
      id
      processedOn
      progress
    }
  }
`;

export const CREATE_ACTIVITY_CUSTOMER_INVOICE_RETRY = gql`
  mutation createActivityCustomerInvoiceRetry($activityRecordID: ID!, $force: Boolean) {
    createActivityCustomerInvoiceRetry(activityRecordID: $activityRecordID, force: $force) {
      id
      processedOn
      progress
    }
  }
`;

export const CREATE_ACTIVITY_SUPPLIER_INVOICE = gql`
  mutation createActivitySupplierInvoice($activityRecordID: ID!, $force: Boolean, $byPassComplianceCheck: Boolean) {
    createActivitySupplierInvoice(
      activityRecordID: $activityRecordID
      force: $force
      byPassComplianceCheck: $byPassComplianceCheck
    ) {
      id
      processedOn
      progress
    }
  }
`;

export const CREATE_ACTIVITY_SUPPLIER_INVOICE_RETRY = gql`
  mutation createActivitySupplierInvoiceRetry(
    $activityRecordID: ID!
    $force: Boolean
    $byPassComplianceCheck: Boolean
  ) {
    createActivitySupplierInvoiceRetry(
      activityRecordID: $activityRecordID
      force: $force
      byPassComplianceCheck: $byPassComplianceCheck
    ) {
      id
      processedOn
      progress
    }
  }
`;

export const CREATE_BILLING_CUSTOMER_INVOICE = gql`
  mutation createBillingCustomerInvoice($billingRecordID: ID!, $force: Boolean) {
    createBillingCustomerInvoice(billingRecordID: $billingRecordID, force: $force) {
      id
      processedOn
      progress
    }
  }
`;

export const UPSERT_BLOOMER = gql`
  mutation upsertBloomer($input: bloomerInput!) {
    upsertBloomer(input: $input) {
      recordId
      firstname
      lastname
      email
      secondaryEmail
      phoneNumber
      slack
      credentialID
      communicationType
      accountManager {
        recordId
      }
      mission {
        recordId
      }
    }
  }
`;

export const FINISH_INVITATION = gql`
  mutation finishInvitation($token: String!) {
    finishInvitation(token: $token)
  }
`;

export const CLIENT_RELAUNCH_CRA = gql`
  mutation relaunchInviteClientCRA($signingDocumentId: ID!) {
    relaunchInviteClientCRA(signingDocumentId: $signingDocumentId)
  }
`;

export const UPSERT_BILLING = gql`
  mutation upsertBilling($input: BillingInput!) {
    upsertBilling(input: $input) {
      customerName
      salesPriceWithoutTaxes
      trialPeriodEndDate
      billingDate
      description
      nextStep
      recordId
      billed
      externalId
      billingContactFullname
      replacement
      paymentTerms
      origin
      cancelled
      lastCustomerInvoiceError
      taxes
      externalCustomerInvoiceId
      externalCustomerInvoiceUrl
      bdc
      businessType
      invoiceStatus
      paymentTermsDetails
    }
  }
`;

export const BOOM_MUTATION = gql`
  mutation boomUpdate {
    boomUpdate
  }
`;

export const BLOOMER_RELAUNCH_CRA = gql`
  mutation relaunchBloomerCRA($missionId: ID!, $month: Date) {
    relaunchBloomerCRA(missionId: $missionId, month: $month)
  }
`;

export const DECLARE_ZERO_ACTIVITY_FOR_MISSION = gql`
  mutation declareZeroActivityForMission($input: DeclareZeroActivityForMissionInput!) {
    declareZeroActivityForMission(input: $input) {
      recordId
      month
      CRAStatus
    }
  }
`;

export const UPDATE_PREFERENCES = gql`
  mutation updatePreferences($preferences: PreferencesInput) {
    updatePreferences(preferences: $preferences)
  }
`;

export const DELETE_MISSION = gql`
  mutation deleteMission($missionId: String!, $lostReason: DeleteMissionLostPostWinReason!, $otherLostReason: String) {
    deleteMission(missionId: $missionId, lostReason: $lostReason, otherLostReason: $otherLostReason) {
      message
    }
  }
`;

export const CREATE_PRICING = gql`
  mutation addPricing($input: addPricingInput!) {
    addPricing(input: $input) {
      startDate
      purchasePricePerDayWithoutTaxes
      salePricePerDayWithoutTaxes
      taxes
      recordId
    }
  }
`;

export const STOP_MISSION = gql`
  mutation stopMission($endMission: String!, $recordId: ID!) {
    stopMission(endMission: $endMission, recordId: $recordId)
  }
`;

export const CREATE_MISSION_AMENDMENT = gql`
  mutation createMissionAmendment($input: CreateMissionAmendmentGQLInput!) {
    createMissionAmendment(input: $input)
  }
`;

export const UPDATE_MISSION = gql`
  mutation updateMission($input: UpdateMissionGQLInput) {
    updateMission(input: $input) {
      recordId
    }
  }
`;

export const UPSERT_NPS_FOLLOWUP = gql`
  mutation missionFollowUp($input: NPSScoringInput) {
    missionFollowUp(input: $input) {
      recordId
    }
  }
`;

export const UPDATE_NOTIFICATION = gql`
  mutation updateNotification($recordId: ID, $read: Boolean) {
    updateNotification(recordId: $recordId, read: $read) {
      recordId
      title
      description
      priority
      type
      read
      canDelete
      creationDate
      mission
      society
      link
    }
  }
`;

export const DELETE_ALL_NOTIFICATION = gql`
  mutation deleteAllNotification {
    deleteAllNotification
  }
`;

export const READ_ALL_NOTIFICATION = gql`
  mutation readAllNotification {
    readAllNotification
  }
`;

export const UPSERT_SOCIETY = gql`
  mutation upsertSociety($input: societyInput!) {
    upsertSociety(input: $input) {
      recordId
      name
      status
      siret
      mission {
        recordId
      }
    }
  }
`;

export const UPSERT_BLOOMER_SOCIETY = gql`
  mutation upsertBloomerSociety($input: bloomerSocietyInput!) {
    upsertBloomerSociety(input: $input) {
      recordId
      name
      status
      siret
      bloomerBillingMission
      IBAN
      BIC
      KBIS
      KbisExpirationDate
      URSSAFVigilanceCertificate
      URSSAFVCExpirationDate
      RCPVigilanceCertificate
      RCPExpirationDate
      portage
      addressCountryCode
      tva
    }
  }
`;

export const UPSERT_EXTESION_ASSESSMENT = gql`
  mutation upsertExtensionAssessment($input: UpsertExtensionAssessmentGQLInput) {
    upsertExtensionAssessment(input: $input) {
      missionId
      assessment
      newEndDate
      createdBy
      createdAt
      updatedBy
      updatedAt
    }
  }
`;

export const UPLOAD_AMENDMENT = gql`
  mutation uploadAmendment($input: UploadAmendmentGQLInput!) {
    uploadAmendment(input: $input) {
      recordId
      type
      step
      status
      nbSigner
      signedCount
      emptyFileUrl
      signedFileUrl
      signedDate
      externalDocumentId
    }
  }
`;

export const DELETE_ACTIVITY_SUPPLIER_INVOICE = gql`
  mutation deleteActivitySupplierInvoice($activityRecordID: ID!, $force: Boolean) {
    deleteActivitySupplierInvoice(activityRecordID: $activityRecordID, force: $force) {
      id
    }
  }
`;

export const VALIDATE_CRA = gql`
  mutation validateCRA($activityRecordID: ID!, $validate: Boolean, $signerFullname: String) {
    validateCRA(activityRecordID: $activityRecordID, validate: $validate, signerFullname: $signerFullname) {
      recordId
      validated
    }
  }
`;
